import Plyr from 'plyr';
import {defineComponent} from "@/js/utils/alpine";

export default defineComponent(() => ({
    init() {
        const plyr = new Plyr(this.$root, {
            ratio: '16:9',
        });
        plyr.on('play', () => {
            console.log('Video playing');
        });
    }
}))
